import { applyMiddleware, compose, legacy_createStore } from "redux";
import { thunk } from "redux-thunk";
import rootPageReducer from "./reducerRoot";
import { useDispatch, useSelector, useStore } from 'react-redux';

// @ts-ignore
const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const storeRoot = legacy_createStore(rootPageReducer, {}, composeEnhancers(applyMiddleware(thunk)));

export type StoreRoot = typeof storeRoot;
export type StoreRootState = ReturnType<StoreRoot['getState']>;
export type StoreRootDispatch = StoreRoot['dispatch'];
export const useDispatchRoot = useDispatch.withTypes<StoreRootDispatch>();
export const useSelectorRoot = useSelector.withTypes<StoreRootState>();
export const useStoreRoot = useStore.withTypes<StoreRoot>();

